import React, { useState, useEffect } from 'react';
import { getLoanApi } from '../../api/loan';
import { Grid, Button, Modal } from '@material-ui/core';

import { connect } from 'react-redux';
import action from '../../store/action/index';
import OneLoan from '../Loan/OneLoan';
import BackButton from '../../components/BackButton';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  paper: {
    width: 300,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid transparent',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    margin: 'auto',
    marginTop: '25vh'
  }
}));

const Details = React.memo(({ location, global_action_loading, history, auth }) => {
  const loan_id = Number(location.search.split('=')[1]);
  const [loan, setLoan] = useState({});
  const classes = useStyles();
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const handleCreateOpen = () => {
    setOpenCreateModal(true);
  };
  const handleCreateCloseModal = () => {
    setOpenCreateModal(false);
  };

  useEffect(() => {
    global_action_loading();
    getLoanApi({ id: loan_id, role: auth })
      .then(res => {
        global_action_loading(false);
        if (res.data.status === 200) {
          setLoan(res.data.data);
        } else {
          history.goBack();
        }
      })
      .catch(err => {
        global_action_loading(false);
        history.goBack();
      });
  }, [global_action_loading, loan_id, history, auth]);

  return (
    <React.Fragment>
      <BackButton path='/loan' />

      <Grid item md={10} sm={12} xs={12} lg={9}>
        {loan.name ? (
          <React.Fragment>
            {' '}
            <OneLoan loan={loan} />
            <div>
              <h4>Transactions: </h4>
              {loan.transactions.map((i, index) => (
                <div key={index}>
                  {i.date} {i.amount} {i.type}
                </div>
              ))}
              <Button style={{ background: 'lightblue' }} onClick={handleCreateOpen}>
                Create Transaction
              </Button>
              <br /> <h4>Statements: </h4>
              {loan.statements.map((i, index) => (
                <div key={index}>
                  {i.date}
                  {i.current_balance}
                  {i.withdrawal}
                  {i.establishment_fee}
                  {i.line_fee}
                  {i.interest}
                  {i.default_interest}
                  {i.payment}
                </div>
              ))}
            </div>
          </React.Fragment>
        ) : (
          <div></div>
        )}
      </Grid>
      <Modal
        aria-labelledby='simple-modal-title'
        aria-describedby='simple-modal-description'
        open={openCreateModal}
        onClose={handleCreateCloseModal}
      >
        <div className={classes.paper}>123</div>
      </Modal>
    </React.Fragment>
  );
});

export default connect(null, action.globalLoading)(Details);
